var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['rowset']},[_c('Label',{staticClass:"rowset__label",attrs:{"for":_vm.uid,"labelText":_vm.labelText}}),_c('div',{staticClass:"rowset__content"},[_vm._t("rowset-content")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }